import { GetAuthUserinfo } from "@/api/api";
import Cookie from "js-cookie";

// 常量定义
const STORAGE_KEYS = {
  OPENID: "wx_openid",
  TOKEN: "wx_token",
  USER: "wx_mp"
};

// 统一URL参数解析函数
const getUrlParam = paramName => {
  const url = location.href;
  const queryString = url.indexOf("?") > -1 ? url.split("?")[1] : "";
  const params = {};

  if (!queryString) return "";

  queryString.split("&").forEach(param => {
    if (!param) return;
    const [key, value] = param.split("=");
    if (key) params[key.toLowerCase()] = value || "";
  });

  return params[paramName.toLowerCase()] || "";
};

// 清除URL中的授权相关参数
const getCleanUrl = () => {
  let url = location.href;
  const paramsToRemove = ["code", "zyauthcode1", "zyauthcode2"];

  paramsToRemove.forEach(param => {
    // 清理各种形式的参数
    const regExp1 = new RegExp(`&${param}=[^&]*`, "gi");
    url = url.replace(regExp1, "");

    const regExp2 = new RegExp(`[\\?&]${param}=[^&]*&`, "gi");
    url = url.replace(regExp2, url.includes("?") ? "&" : "?");

    const regExp3 = new RegExp(`[\\?&]${param}=[^&]*$`, "gi");
    url = url.replace(regExp3, "");
  });

  // 确保使用https
  if (url.indexOf("https://") < 0) {
    url = url.replace("http://", "https://");
  }

  return url;
};

// 页面路由映射表
const ROUTES = {
  dzp: params =>
    `#dzp?onLinetype=${params.onLinetype || ""}&SourceUid=${params.SourceUid ||
      ""}&ParentUid=${params.ParentUid || ""}`,
  template: params =>
    `#template?onLinetype=${params.onLinetype ||
      ""}&SourceUid=${params.SourceUid || ""}&ParentUid=${params.ParentUid ||
      ""}`,
  bullet_chat: params =>
    `#bullet_chat?onLinetype=${params.onLinetype ||
      ""}&SourceUid=${params.SourceUid || ""}&ParentUid=${params.ParentUid ||
      ""}&isDzp=${params.isDzp || ""}`,
  sign: params =>
    `#sign?SourceUid=${params.SourceUid || ""}&ParentUid=${params.ParentUid ||
      ""}`,
  luck_grid: params => `#luck_grid?onLinetype=${params.onLinetype || ""}`,
  // 简单路由（无参数）
  form: "#form",
  dzp1: "#dzp1",
  obtain: "#obtain",
  material_exhibition: "#material_exhibition",
  flip_game: "#flip_game",
  shake: "#shake",
  "photograph-Expo": "#photograph-Expo",
  form2024: "#form2024",
  guide_page: "#guide_page",
  form2024info: "#form2024info",
  claimprize: "#claimprize",
  "2048": "#2048",
  SHmarathon2025: "#SHmarathon2025?first=1", //额外增加了 首次进来的参数，方便个别设备调整
  christmasGame: "#christmasGame"
};

// 产品页面路由前缀数组
const PRODUCT_ROUTES = [
  "product-H1",
  "product-H2",
  "product-H3",
  "product-H4",
  "product-H5",
  "product-H6",
  "product-H7",
  "product-H8",
  "product-H9",
  "product-H10",
  "product-L1",
  "product-L2",
  "product-L3",
  "product-L4",
  "product-L5",
  "product-L6",
  "product-L7",
  "product-L8-5",
  "product-L9-2",
  "product-L9-3",
  "product-L9-4",
  "product-L9",
  "product-m1",
  "product-m2",
  "product-m3",
  "product-m3-2",
  "product-m4",
  "product-m5",
  "product-m5-2",
  "product-m6",
  "product-m7",
  "product-m8",
  "product-m9-11",
  "product-m12-14",
  "product-N1",
  "product-N2",
  "product-N3",
  "product-N4"
];

// 处理页面重定向
const handleRedirect = () => {
  const currentUrl = location.href;
  const params = {
    onLinetype: getUrlParam("onLinetype"),
    SourceUid: getUrlParam("SourceUid"),
    ParentUid: getUrlParam("ParentUid"),
    isDzp: getUrlParam("isDzp")
  };

  // 检查特殊路由
  for (const [route, urlGenerator] of Object.entries(ROUTES)) {
    if (currentUrl.indexOf(route) > 0) {
      // 特殊处理shake路由
      if (route === "shake") {
        window.history.pushState(null, null, "#");
      }

      const targetUrl =
        process.env.host_url +
        (typeof urlGenerator === "function"
          ? urlGenerator(params)
          : urlGenerator);
      window.location.replace(targetUrl);
      return;
    }
  }

  // 检查产品页面路由
  for (const prefix of PRODUCT_ROUTES) {
    if (currentUrl.indexOf(prefix) > 0) {
      window.location.replace(`${process.env.host_url}#${prefix}`);
      return;
    }
  }
};

// 微信授权请求
const requestWxAuth = () => {
  const cleanUrl = getCleanUrl();
  //线上
  const jumpUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    process.env.Appid
  }&redirect_uri=${encodeURIComponent(
    cleanUrl
  )}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;

  //线下
  //如果是绿色授权需要拿openid code后面+3 snsapi_userinfo
  //如果不是绿色授权需要拿openid code后面+1 snsapi_base
  window.location.replace(jumpUrl);
};

// 处理微信授权回调
const handleWxAuthCallback = code => {
  GetAuthUserinfo({
    Appid: process.env.Appid,
    ZYAuthCode: code + "3", // 绿色授权追加"3"
    GetToken: true
  }).then(res => {
    if (res.Code == 200) {
      const { User, Token } = res.DataMap;

      // 存储用户数据
      localStorage.setItem(STORAGE_KEYS.OPENID, User.Openid);
      localStorage.setItem(STORAGE_KEYS.TOKEN, Token);
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(User));
      Cookie.set("CookieToken", Token);

      // 延迟跳转，避免白屏
      setTimeout(handleRedirect, 800);
    } else {
      requestWxAuth();
    }
  });
};

/**
 * 微信授权入口函数
 */
export const authUrl = () => {
  const code = getUrlParam("code");
  if (!code) {
    console.log("我当前没有Code");
    requestWxAuth();
  } else {
    console.log("我当前有Code");
    handleWxAuthCallback(code);
  }
};



// WEBPACK FOOTER //
// ./src/utils/jump.js